import React, { Component } from 'react';
import TasksUpListPopUp from './TasksUpListPopUp';

// eslint-disable-next-line react/prefer-stateless-function
class TasksUpListPopUpRWrapper extends Component {
  render() {
    return (
      <React.Fragment>
        <TasksUpListPopUp {...this.props} />
      </React.Fragment>
    );
  }
}

export default TasksUpListPopUpRWrapper;



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksUpListPopUpNew/index.js